<!--企业箱子管理-->
<template>
    <div class="business-content-main" v-loading="loading" element-loading-spinner="none">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询（F2）</el-button>
                <el-button size="small" type="primary" class="search-btn" @click="editBoxes(0)" v-if="permission.add">新增箱子</el-button>
                <el-button size="small" type="primary" class="search-btn" @click="editBoxes(2)" v-if="permission.batchAdd">批量新增</el-button>
                <el-button size="small" type="primary" class="search-btn" @click="batchPrintBox" v-if="permission.batchPrintBox">批量打印</el-button>
                <el-button size="small" type="danger" class="search-btn" @click="batchDestroy" v-if="permission.batchDestroy">批量销毁</el-button>
                <el-button size="small" type="primary" class="search-btn" @click="storeBoxes" v-if="permission.storeBoxes">存放箱子</el-button>
                <el-button size="small" type="primary" class="search-btn" @click="storeGoods" v-if="permission.storeGoods">存放商品</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border=""
                    style="width: 100%"
                    @cell-dblclick="handleDBClick"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column width="180px" prop="Code" label="箱子码" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="Name" label="箱子名称" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="GoodsCount" label="货物数量" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="StorageName" label="存放仓库" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="SpaceName" label="存放仓位" show-overflow-tooltip></el-table-column>
                    <el-table-column width="100" show-overflow-tooltip label="箱子状态">
                        <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                    </el-table-column>
                    <el-table-column prop="Remark" label="备注" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="PrintCount" label="打印次数" show-overflow-tooltip></el-table-column>
                    <el-table-column width="80px" prop="Creator" label="创建人" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="160px" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button
                                    type="text"
                                    size="mini"
                                    @click="editBoxes(1, scope.row)"
                                    v-if="permission.edit && scope.row.State == '0' && !scope.row.IsTuoGuan"
                                    >{{ permission.edit }}</el-button
                                >
                                <el-button
                                    type="text"
                                    size="mini"
                                    @click="printBox(scope.row)"
                                    v-if="permission.printBox && scope.row.State != '2' && !scope.row.IsTuoGuan"
                                    >{{ permission.printBox }}</el-button
                                >
                                <el-button
                                    type="text"
                                    size="mini"
                                    style="color: red"
                                    @click="destroy(scope.row)"
                                    v-if="permission.destroy && scope.row.State == '0' && !scope.row.IsTuoGuan"
                                    >{{ permission.destroy }}</el-button
                                >
                                <el-button type="text" size="mini" @click="opRecords(scope.row)" v-if="permission.opRecords && !scope.row.IsTuoGuan">{{
                                    permission.opRecords
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <el-dialog :close-on-click-modal="false" title="箱子的一生" :visible.sync="boxLifesVisible" width="1000px">
            <div class="dialog-content" v-if="boxLifesVisible">
                <div>
                    <div class="search-ctn" style="padding-top: 0; padding-left: 10px; padding-right: 10px">
                        <div class="search-name">箱子编码：{{ boxLifes.Code }}</div>
                        <div class="search-name">箱子名称：{{ boxLifes.Name }}</div>
                        <div class="search-name">商品种类：{{ boxLifes.TypeCount }}</div>
                        <div class="tooMuchAS">货物总数：{{ boxLifes.GoodsCount }}</div>
                    </div>
                    <div class="table-ctn">
                        <el-table
                            :header-cell-style="{ background: '#F2F6FC' }"
                            :data="boxLifes.DataList"
                            border=""
                            style="width: 100%; margin-bottom: 10px"
                            min-height="530px"
                        >
                            <el-table-column fixed show-overflow-tooltip label="操作类型" width="160" prop="OpTypeName"> </el-table-column>
                            <el-table-column show-overflow-tooltip min-width="200" prop="Remark" label="操作说明">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.Remark }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip width="160" prop="CreateTime" label="操作时间"></el-table-column>
                            <el-table-column show-overflow-tooltip width="80" prop="Oper" label="操作人"></el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="箱子存放数据" :visible.sync="boxDetailVisible" width="1000px">
            <div class="dialog-content" v-if="boxDetailVisible">
                <boxDetail :edit="false" :BoxId="boxId"></boxDetail>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            :title="editBoxModel.atype == 0 ? '新增箱子' : editBoxModel.atype == 1 ? '编辑箱子' : '批量新增箱子'"
            :visible.sync="editBoxVisible"
            width="400px"
            class="editBox-item-dialog"
        >
            <div class="dialog-content" v-if="editBoxVisible" v-loading="loading">
                <div>
                    <el-form :model="editBoxModel" ref="editForm" label-position="left" label-width="80px" :rules="rules">
                        <el-form-item label="编码" v-if="editBoxModel.atype == 1" prop="Code">
                            <el-input style="width: 100%" v-model.trim="editBoxModel.Code" disabled="" size="small"> </el-input>
                        </el-form-item>
                        <el-form-item label="名称" v-if="editBoxModel.atype !== 2" prop="Name" :rules="[{ required: editBoxModel.atype !== 2, message: '名称不能为空' }]">
                            <el-input style="width: 100%" v-model.trim="editBoxModel.Name" size="small"> </el-input>
                        </el-form-item>
                        <el-form-item label="备注" v-if="editBoxModel.atype !== 2" prop="Remark">
                            <el-input style="width: 100%" v-model.trim="editBoxModel.Remark" size="small"> </el-input>
                        </el-form-item>
                        <el-form-item label="箱子数量" v-if="editBoxModel.atype == 2" prop="AddCount">
                            <el-input-number size="small" placeholder="请输入" :min="1" :max="100" v-model="editBoxModel.AddCount"></el-input-number>
                        </el-form-item>
                     <el-form-item label="仓库" v-if="editBoxModel.atype != 1">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="editBoxModel.WarehouseId"
                            filterable
                            clearable
                            @visible-change="wHVisibleChange_edit($event)"
                            @change="warehouseChange_edit($event)"
                        >
                            <el-option v-for="optionItem in warehouseList_edit" :key="optionItem.WarehouseId" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId">
                                <div class="option-content">
                                    <div>{{ optionItem.WarehouseName }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="仓位" v-if="editBoxModel.atype != 1">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="editBoxModel.SpaceId"
                            reserve-keyword
                            remote
                            :remote-method="val => remoteMethod_edit(val)"
                            v-select-scroll-more="remoteMethodScrollMore_edit"
                            filterable
                            clearable
                            v-loading="spaceloading_edit"
                        >
                            <el-option v-for="optionItem in spaceList_edit" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId">
                                <div class="option-content">
                                    <div>{{ optionItem.ShelfSpaceCode }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>                                           
                    </el-form>
                    <div class="dialog-footer">
                        <el-button class="btn-primary" size="small" @click="submitForm" :disabled="isStopReq">提交</el-button>
                        <el-button
                            @click="
                                () => {
                                    editBoxVisible = false;
                                }
                            "
                            size="small"
                            :disabled="isStopReq"
                            >取消</el-button
                        >
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="箱子搜索"
            :visible.sync="dialogVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-label-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="箱子码">
                        <el-input class="search-item" v-model.trim="searchData.Code" size="small" placeholder="标签码" ref="search_lc"></el-input>
                    </el-form-item>
                    <el-form-item label="箱子名称">
                        <el-input class="search-item" v-model.trim="searchData.Name" size="small" placeholder="箱子名称" ref="search_ln"></el-input>
                    </el-form-item>
                    <el-form-item label="箱子状态">
                        <el-select class="search-item" size="small" v-model="searchData.State" style="width: 100%">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="货物数">
                        <div class="flex">
                            <el-select size="small" class="search-item" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input ref="search_4" class="search-item" size="small" style="width: 90px" v-model.trim="searchData.Invent1"></el-input>
                            <el-input
                                class="search-item"
                                size="small"
                                style="width: 90px"
                                v-model.trim="searchData.Invent2"
                                v-if="searchData.Symbol == 'between'"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="仓库">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.WarehouseId"
                            filterable
                            clearable
                            @visible-change="wHVisibleChange($event)"
                            @change="warehouseChange($event)"
                        >
                            <el-option
                                v-for="optionItem in warehouseList"
                                :key="optionItem.WarehouseId"
                                :label="optionItem.WarehouseName"
                                :value="optionItem.WarehouseId"
                            >
                                <div class="option-content">
                                    <div>{{ optionItem.WarehouseName }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="仓位">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.SpaceId"
                            reserve-keyword
                            remote
                            :remote-method="val => remoteMethod(val)"
                            v-select-scroll-more="remoteMethodScrollMore"
                            filterable
                            clearable
                            v-loading="spaceloading"
                        >
                            <el-option v-for="optionItem in spaceList" :key="optionItem.ShelfSpaceId" :label="optionItem.ShelfSpaceCode" :value="optionItem.ShelfSpaceId">
                                <div class="option-content">
                                    <div>{{ optionItem.ShelfSpaceCode }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建人">
                        <el-select size="small" style="width: 100%" v-model="searchData.CreatorId" class="search-item" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
import boxDetail from '@/components/business/goods/boxDetail';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'boxesList',
    components: {
        breadcrumb,
        elTableColumn,
        boxDetail
    },
    data() {
        return {
            datetime1: '',
            datetime2: '',
            SIdList: [],
            noData: false,
            dialogVisible: false,
            isStopReq: false,
            loading: false,
            searchData: {
                Code: '',
                Name: '',
                State: '0',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CreatorId: '',
                SearchType: 2,
                WarehouseId: '',
                SpaceId: '',
                page: 1,
                limit: this.commonPageSize
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '正常', Value: '0' },
                { Text: '未存放', Value: '3' },
                { Text: '已离仓', Value: '1' },
                { Text: '已销毁', Value: '2' }
            ],
            multipleSelection: [],
            isStartSearch: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            warehouseList: [],
            spaceList: [],
            spaceloading: false,
            currentShelfSpaceObj: {}, // 当前的下拉框仓位数据
            boxLifesVisible: false,
            boxLifes: {
                Code: '',
                Name: '',
                TypeCount: 0,
                GoodsCountL: 0,
                DataList: []
            },
            boxDetailVisible: false,
            editBoxVisible: false,
            editBoxModel: {
                atype: 0,
                BoxId: '',
                Name: '',
                Code: '',
                Remark: '',
                AddCount: 1,
                SpaceId:'',
                WarehouseId:''
            },
            rules: {
                // Name: [{ message: '名称不能为空', trigger: 'blur' }],
            },
            boxId: '',
            warehouseList_edit: [],
            spaceList_edit: [],
            spaceloading_edit: false,
            currentShelfSpaceObj_edit: {}, // 当前的下拉框仓位数据
        };
    },
    //当前页面使用了keepAlive,不会触发beforeDestroy钩子
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogVisible) this.dialogVisible = false;
        next();
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        this.getTableData();
        this.permission = this.$util.getPermission('boxes');
        this.getSIdList();
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常';
            } else if (value == 2) {
                return '已销毁';
            } else if (value == 1) {
                return '已离仓';
            }
        }
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_lc.focus();
                });
            }
        }
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;

            let key = window.event.keyCode;
            if (key === 113) {
                if (that.boxLifesVisible || that.boxDetailVisible || that.editBoxVisible) {
                    e.preventDefault();
                    return;
                }
                e.preventDefault();
                this.dialogVisible = true;
                this.isStartSearch = true;
                return;
            }
            if (key === 13) {
                if (that.boxLifesVisible || that.boxDetailVisible || that.editBoxVisible) {
                    e.preventDefault();
                    return;
                }
                e.preventDefault();
                that.handleSearch();
                return;
            }
            if (key === 27) {
                if (that.boxLifesVisible || that.boxDetailVisible || that.editBoxVisible) {
                    e.preventDefault();
                    return;
                }
                e.preventDefault();
                if (this.dialogVisible) {
                    this.dialogVisible = false;
                    this.isStartSearch = false;
                }
                return;
            }
            //右键
            if (key === 39) {
                if (that.boxLifesVisible || that.boxDetailVisible || that.editBoxVisible) {
                    e.preventDefault();
                    return;
                }
                e.preventDefault();
                if (!this.dialogVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                if (that.boxLifesVisible || that.boxDetailVisible || that.editBoxVisible) {
                    e.preventDefault();
                    return;
                }
                e.preventDefault();
                if (!that.dialogVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        showSearchDialog() {
            this.dialogVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog() {
            this.dialogVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        // 重置表单
        resetSearch() {
            this.searchData = {
                Code: '',
                Name: '',
                State: '0',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                StartDate: '',
                EndDate: '',
                CreatorId: '',
                UStartDate: '',
                UEndDate: '',
                page: 1,
                limit: this.commonPageSize,
                SearchType: 2,
                WarehouseId: '',
                SpaceId: ''
            };
            this.datetime1 = [];
            this.datetime2 = [];
            this.spaceList = [];
        },
        // 关闭弹窗
        closeDialog(edit) {
            if (edit) {
                this.getTableData();
            }
        },
        // 获取数据
        getTableData() {
            if (!this.isStopReq) {
                this.isStopReq = true;
                this.loading = true;
                this.$util
                    .axiosPost({
                        url: '/api/EntpBoxes/GetBoxesList',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) {
                            this.noData = true;
                            this.tableData = [];
                            this.tableDataLength = 0;
                            return;
                        }
                        this.noData = false;
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.isStopReq = false;
                        this.loading = false;
                    });
            }
        },
        editBoxes(atype, row) {
            let that = this;
            that.editBoxModel = {
                atype: atype,
                BoxId: '',
                Name: '',
                Code: '',
                Remark: '',
                AddCount: 1,
                SpaceId:'',
                WarehouseId:''                
            };
            if (atype == 0) {
                that.editBoxVisible = true;
            } else if (atype == 1) {
                if (!row || !row.BoxId) {
                    this.$util.warningMsg('箱子异常！');
                    return;
                }
                that.editBoxModel.BoxId = row.BoxId;
                that.editBoxModel.Code = row.Code;
                that.editBoxModel.Name = row.Name;
                that.editBoxModel.Remark = row.Remark;
                that.editBoxVisible = true;
            } else if (atype == 2) {
                that.editBoxVisible = true;
            }
        },
        printBox(row) {
            let that = this;
            if (row) {
                that.$util
                    .axiosPost({
                        url: '/api/EntpBoxes/PrintBoxes',
                        data: {
                            BoxId: row.BoxId
                        }
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('打印成功');
                            that.getTableData();
                        } else {
                            that.$util.successMsg(res.errmsg);
                        }
                    });
            }
        },
        batchPrintBox() {
            let that = this;
            if (that.multipleSelection.length == 0) {
                that.$util.warningMsg('请选择箱子');
                return;
            }
            let boxIds = [];
            for (let i = 0; i < that.multipleSelection.length; i++) {
                if (that.multipleSelection[i].State == 2) {
                    that.$util.warningMsg('已销毁的箱子不可打印');
                    return;
                }
                if (that.multipleSelection[i].IsTuoGuan) {
                    that.$util.warningMsg('前置仓标签不可操作');
                    return;
                }
                boxIds.push(that.multipleSelection[i].BoxId);
            }
            that.$util.elConfirm({
                content: '确定要打印标签吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpBoxes/PrintBoxes',
                            data: {
                                BoxIds: boxIds
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('打印完成');
                                that.multipleSelection = [];
                                that.getTableData();
                            } else {
                                that.$util.successMsg(res.errmsg);
                            }
                        });
                }
            });
        },
        destroy(row) {
            let that = this;
            that.$util.elConfirm({
                content: '确定销毁该箱子吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpBoxes/DestroyBox',
                            data: {
                                BoxId: row.BoxId
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('成功销毁箱子');
                                that.getTableData();
                            } else that.$util.successMsg(res.errmsg);
                        });
                }
            });
        },
        batchDestroy() {
            let that = this;
            if (that.multipleSelection.length == 0) {
                that.$util.warningMsg('请选择箱子');
                return;
            }
            let boxIds = [];
            for (let i = 0; i < that.multipleSelection.length; i++) {
                if (that.multipleSelection[i].State != 0) {
                    that.$util.warningMsg('已销毁或已离仓的箱子不可销毁');
                    return;
                }
                if (that.multipleSelection[i].IsTuoGuan) {
                    that.$util.warningMsg('前置仓箱子不可操作');
                    return;
                }
                boxIds.push(that.multipleSelection[i].BoxId);
            }
            that.$util.elConfirm({
                content: '确定要销毁印标签吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/EntpBoxes/BatchDestroyBoxes',
                            data: {
                                BoxIds: boxIds
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('成功销毁标签');
                                that.multipleSelection = [];
                                that.getTableData();
                            } else {
                                that.$util.successMsg(res.errmsg);
                            }
                        });
                }
            });
        },
        opRecords(row) {
            let that = this;
            that.boxLifes = {
                Code: '',
                Name: '',
                TypeCount: 0,
                GoodsCountL: 0,
                DataList: []
            };
            that.$util
                .axiosGet({
                    url: '/api/EntpBoxes/GetBoxLifes',
                    data: {
                        BoxId: row.BoxId
                    }
                })
                .then(res => {
                    if (res.errcode == 0) {
                        let data = res.data;
                        that.boxLifes.Code = data.Code;
                        that.boxLifes.Name = data.Name;
                        that.boxLifes.GoodsCount = data.GoodsCount;
                        that.boxLifes.TypeCount = data.TypeCount;
                        that.boxLifes.DataList = data.DataList;
                        that.boxLifesVisible = true;
                    } else that.$util.successMsg(res.errmsg);
                });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(row) {
            let that = this;
            if (row.BoxId) {
                that.boxId = row.BoxId;
                that.boxDetailVisible = true;
            }
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    this.$util.getWarehouse().then(data => {
                        this.warehouseList = data;
                    });
                }
            }
        },
        warehouseChange(value) {
            this.spaceList = [];
            this.searchData.SpaceId = '';
            if (value) {
                this.currentShelfSpaceObj = { Page: 1, StopLoad: false };
                this.searchPosition(this.currentShelfSpaceObj);
            }
        },
        // 仓位下拉框滚动加载
        remoteMethodScrollMore() {
            this.remoteMethod();
        },
        /**
         * 搜索仓位
         * 支持远程搜索和滚动下拉加载更多
         *   通过 val 判断是哪种情况，非空时是远程搜索
         */
        remoteMethod(val) {
            let obj = this.currentShelfSpaceObj;
            if (val) {
                // 远程搜索，重置搜索项
                obj.Key = val;
                obj.Page = 1;
                obj.StopLoad = false;
                this.spaceList = [];
            } else {
                // 下拉加载更多
                obj.Page += 1;
            }
            if (obj.StopLoad) return;
            this.searchPosition({
                Key: obj.Key,
                Page: obj.Page
            }).then(() => {
                let row = {
                    ...obj
                    // StopLoad: this.spaceList.length < 20
                };
                this.currentShelfSpaceObj = row;
            });
        },
        // 搜仓位
        searchPosition(obj) {
            let that = this;
            if (!that.searchData.WarehouseId || that.spaceloading) return;
            that.spaceloading = true;
            return that.$util
                .GetShelfSpacesList({
                    WarehouseId: that.searchData.WarehouseId,
                    ShelfSpaceCode: obj.Key,
                    Page: obj.Page,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: true
                })

                .then(res => {
                    that.spaceloading = false;
                    if (res.data) {
                        that.spaceList = that.spaceList.concat(res.data);
                        this.currentShelfSpaceObj.StopLoad = that.spaceList.length >= res.count;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.spaceloading = false;
                });
        },
        submitForm() {
            let that = this;
            that.$refs.editForm.validate(valid => {
                if (valid) {
                    if (that.isStopReq) {
                        return;
                    }
                    if (that.editBoxModel.atype == 2) {
                        if (!Number.isInteger(that.editBoxModel.AddCount)) {
                            that.$util.warningMsg('箱子数量必须是正整数');
                            return;
                        }
                    }
                    that.isStopReq = true;
                    that.loading = true;
                    let url = '/api/EntpBoxes/EditBoxes';
                    if (that.editBoxModel.atype == 2) url = '/api/EntpBoxes/BattchAddBoxes';
                    that.$util
                        .axiosPost({
                            url: url,
                            data: that.editBoxModel,
                            hideLoading: true
                        })
                        .then(() => {
                            that.$util.successMsg('提交成功');
                            that.editBoxVisible = false;
                            that.isStopReq = false;
                            that.closeDialog(true);
                            that.loading = false;
                        })
                        .catch(() => {
                            that.isStopReq = false;
                            that.loading = false;
                        });
                }
            });
        },
        storeBoxes() {
            this.$router.push(`/inventoryManage/boxes/scanIn`);
        },
        storeGoods() {
            this.$router.push(`/inventoryManage/boxes/goodsSanIn`);
        },
        wHVisibleChange_edit(event) {
            let that = this;
            if (event) {
                if (that.warehouseList_edit.length == 0) {
                    this.$util.getWarehouse().then(data => {
                        this.warehouseList_edit = data;
                    });
                }
            }
        },
        warehouseChange_edit(value) {
            this.spaceList_edit = [];
            this.editBoxModel.SpaceId = '';
            if (value) {
                this.currentShelfSpaceObj_edit = { Page: 1, StopLoad: false };
                this.searchPosition_edit(this.currentShelfSpaceObj_edit);
            }
        },
        // 仓位下拉框滚动加载
        remoteMethodScrollMore_edit() {
            this.remoteMethod_edit();
        },
        /**
         * 搜索仓位
         * 支持远程搜索和滚动下拉加载更多
         *   通过 val 判断是哪种情况，非空时是远程搜索
         */
        remoteMethod_edit(val) {
            let obj = this.currentShelfSpaceObj_edit;
            if (val) {
                // 远程搜索，重置搜索项
                obj.Key = val;
                obj.Page = 1;
                obj.StopLoad = false;
                this.spaceList_edit = [];
            } else {
                // 下拉加载更多
                obj.Page += 1;
            }
            if (obj.StopLoad) return;
            this.searchPosition_edit({
                Key: obj.Key,
                Page: obj.Page
            }).then(() => {
                let row = {
                    ...obj
                };
                this.currentShelfSpaceObj_edit = row;
            });
        },
        // 搜仓位
        searchPosition_edit(obj) {
            let that = this;
            if (!that.editBoxModel.WarehouseId || that.spaceloading_edit) return;
            that.spaceloading_edit = true;
            return that.$util
                .GetShelfSpacesList({
                    WarehouseId: that.editBoxModel.WarehouseId,
                    ShelfSpaceCode: obj.Key,
                    Page: obj.Page,
                    Limit: 20,
                    IsLimit: true,
                    IncludecWaste: true
                })

                .then(res => {
                    that.spaceloading_edit = false;
                    if (res.data) {
                        that.spaceList_edit = that.spaceList_edit.concat(res.data);
                        this.currentShelfSpaceObj_edit.StopLoad = that.spaceList_edit.length >= res.count;
                    } else {
                        that.$util.warningMsg('该仓库暂无仓位');
                    }
                })
                .catch(error => {
                    that.spaceloading_edit = false;
                });
        },        
    }
};
</script>
<style lang="less" scoped>
#search-label-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .search-item-dialog {
        width: 340px;
        height: auto;
        .dialog-footer {
            text-align: right;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.editBox-item-dialog {
    .dialog-footer {
        text-align: right;
    }
    .el-form-item {
        margin-bottom: 0;
    }
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
</style>
